import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77fc3ed3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arcode-main-toolbar-panel-title panel-title" }, " ArCode Lab ", -1))
const _hoisted_2 = { class: "form-input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Method", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "transpile-src-file" }, "Transpile TS File", -1))
const _hoisted_5 = [
  _hoisted_4
]

import { ref } from 'vue'
import TranspileTSFile from '@/components/atomic/TranspileTSFile'


export default /*#__PURE__*/_defineComponent({
  __name: 'ArCodeLab',
  props: {
  workspace: Object,
  tx: String,
  login: Object,
  tokenState: Object
},
  setup(__props) {

const props = __props;

//import {EditorView} from "@codemirror/view";
const selOption = ref('transpile-src-file')
// eslint-disable-next-line


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("select", {
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetForms())),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selOption).value = $event))
        }, _hoisted_5, 544), [
          [
            _vModelSelect,
            selOption.value,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      (selOption.value === 'transpile-src-file')
        ? (_openBlock(), _createBlock(_unref(TranspileTSFile), {
            key: 0,
            workspace: __props.workspace
          }, null, 8, ["workspace"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})